<button
  mat-icon-button
  matTooltip="Clear Selected"
  (click)="clearSelection.next()"
>
  <mat-icon>refresh</mat-icon>
</button>
